<style lang="less">
.markdown-editor-wrap {
	display: flex;
	flex-direction: column;
	min-height: 200px;
	overflow: hidden;
}
.markdown-editor-wrap.has-height {
	min-height: 0;
	box-sizing: border-box;
}
.markdown-editor-wrap.has-height > * {
	flex: 1;
	min-height: 0;
	overflow: hidden;
	align-self: stretch;
}
/* 子组件 mavon-editor 内部的 .v-note-wrapper / .v-note-panel / .v-note-edit（本 style 未 scoped） */
.markdown-editor-wrap.has-height .v-note-wrapper {
	min-height: 0 !important;
	height: 100% !important;
	max-height: 100% !important;
	flex: 1;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}
.markdown-editor-wrap.has-height .v-note-panel {
	min-height: 0 !important;
	flex: 1;
	overflow: hidden;
}
.markdown-editor-wrap.has-height .v-note-edit {
	min-height: 0 !important;
	flex: 1;
	overflow: auto;
}
.v-note-wrapper {
	min-height: 500px;
}
.v-show-content {
	background: #fff !important;
	.hljs {
		background: none;
	}
	.doc-mermaid {
		margin: 12px 0;
		padding: 12px;
		background: #fafafa;
		border: 1px solid #e4e7ed;
		border-radius: 8px;
		overflow-x: auto;
		text-align: center;
	}
	.doc-mermaid svg {
		max-width: 100%;
		height: auto;
	}
	img[style*='width'] {
		display: block;
		margin: 0.75em auto;
	}
}
.v-note-toolbar {
	z-index: 1000 !important;
	position: relative;
}
.v-note-edit {
	min-height: 400px;
}
</style>
<template>
	<div
		class="markdown-editor-wrap"
		:class="{ 'has-height': editorHeight }"
		:style="wrapStyle"
	>
		<mavon-editor
			:value="value"
			:placeholder="placeholder"
			ref="md"
			@imgAdd="$imgAdd"
			@change="change"
			@input="change"
			:defaultOpen="effectiveDefaultOpen"
			:editable="!preview"
			:toolbarsFlag="!preview"
			:subfield="subfield !== undefined ? subfield : !preview"
			class="markdown-editor-inner"
			:ishljs="true"
			language="json"
			codeStyle="github"
			:tabSize="2"
		/>
	</div>
</template>

<script>
import {mavonEditor} from 'mavon-editor';
import 'mavon-editor/dist/css/index.css';
import {
  extendMarkdownItForDocs,
  initDocumentMermaid,
} from '@/pages/core/documents/document-markdown';

export default {
  name: 'markdown',
  data: function() {
    return {
      content: '',
      html: '',
      configs: {},
    };
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    option: {
      type: Object,
      default: ()=>({}),
    },
    preview: {
      type: Boolean,
    },
    placeholder: {
      type: String,
    },
    /** 是否双栏（编辑+预览），不传时默认非 preview 模式下为 true */
    subfield: {
      type: Boolean,
      default: undefined,
    },
    /** 编辑器整体高度，如 "400px"、"60vh"、"calc(80vh - 120px)"，不传则使用默认 min-height */
    height: {
      type: [String, Number],
      default: '',
    },
  },
  computed: {
    /** 双栏时需 defaultOpen='preview' 才会同时显示编辑与预览 */
    effectiveDefaultOpen() {
      const dual = this.subfield !== undefined ? this.subfield : !this.preview;
      return dual ? 'preview' : (this.preview ? 'preview' : 'edit');
    },
    editorHeight() {
      const h = this.height;
      if (h == null || h === '') return '';
      if (typeof h === 'number') return `${h}px`;
      return String(h);
    },
    wrapStyle() {
      if (!this.editorHeight) return undefined;
      return { height: this.editorHeight };
    },
  },
  components: {
    mavonEditor,
  },
  mounted() {
    this.$nextTick(() => {
      this.setupDocMarkdown();
      this.renderMermaidInPreview();
    });
  },
  methods: {
    setupDocMarkdown() {
      const editor = this.$refs.md;
      if (!editor || !editor.markdownIt) return;
      extendMarkdownItForDocs(editor.markdownIt, {withKatex: false});
      if (typeof editor.iRender === 'function') {
        editor.iRender(true);
      }
    },
    renderMermaidInPreview() {
      const editor = this.$refs.md;
      const root = editor && editor.$refs.vShowContent;
      initDocumentMermaid(root);
    },
    // 将图片上传到服务器，返回地址替换到md中
    $imgAdd(pos, $file) {
      this.$cos.upload([$file], {onSuccess: (files)=>{
        if (files && files.length > 0) {
          this.$refs.md.$img2Url(pos, files[0].url);
        }
      }}, {coskey: this.$store.getters['session/session'].coskey});
    },
    change(value, render) {
      // render 为 markdown 解析后的结果
      this.html = render;
      this.$emit('change', value);
      this.$emit('input', value);
      this.$nextTick(() => this.renderMermaidInPreview());
    },

  },
};
</script>
<style lang="less" scoped>
.editor-btn {
	margin-top: 20px;
}

body {
	margin: 0 auto;
	font-family: "Microsoft YaHei", arial, sans-serif;
	color: #444444;
	line-height: 1;
	padding: 30px;
}
@media screen and (min-width: 768px) {
	body {
		width: 748px;
		margin: 10px auto;
	}
}
h1,
h2,
h3,
h4 {
	color: #111111;
	font-weight: 400;
	margin-top: 1em;
}

h1,
h2,
h3,
h4,
h5 {
	font-family: "微软雅黑", Georgia, Palatino, serif;
}
h1,
h2,
h3,
h4,
h5,
p,
dl {
	margin-bottom: 16px;
	padding: 0;
}
h1 {
	font-size: 48px;
	line-height: 54px;
}
h2 {
	font-size: 36px;
	line-height: 42px;
}
h1,
h2 {
	border-bottom: 1px solid #efeaea;
	padding-bottom: 10px;
}
h3 {
	font-size: 24px;
	line-height: 30px;
}
h4 {
	font-size: 21px;
	line-height: 26px;
}
h5 {
	font-size: 18px;
	list-style: 23px;
}
a {
	color: #0099ff;
	margin: 0;
	padding: 0;
	vertical-align: baseline;
}
a:hover {
	text-decoration: none;
	color: #ff6600;
}
a:visited {
	/*color: purple;*/
}
ul,
ol {
	padding: 0;
	padding-left: 24px;
	margin: 0;
}
li {
	line-height: 24px;
}
p,
ul,
ol {
	font-size: 16px;
	line-height: 24px;
}

ol ol,
ul ol {
	list-style-type: lower-roman;
}

/*pre {
    padding: 0px 24px;
    max-width: 800px;
    white-space: pre-wrap;
}
code {
    font-family: Consolas, Monaco, Andale Mono, monospace;
    line-height: 1.5;
    font-size: 13px;
}*/

code,
pre {
	border-radius: 3px;
	background-color: #f7f7f7;
	color: inherit;
}

code {
	font-family: Consolas, Monaco, Andale Mono, monospace;
	margin: 0 2px;
}

pre {
	line-height: 1.7em;
	overflow: auto;
	padding: 6px 10px;
	border-left: 5px solid #6ce26c;
}

pre > code {
	border: 0;
	display: inline;
	max-width: initial;
	padding: 0;
	margin: 0;
	overflow: initial;
	line-height: inherit;
	font-size: 0.85em;
	white-space: pre;
	background: 0 0;
}

code {
	color: #666555;
}

/** markdown preview plus 对于代码块的处理有些问题, 所以使用统一的颜色 */
/*code .keyword {
  color: #8959a8;
}

code .number {
  color: #f5871f;
}

code .comment {
  color: #998
}*/

aside {
	display: block;
	float: right;
	width: 390px;
}
blockquote {
	border-left: 0.5em solid #eee;
	padding: 0 0 0 2em;
	margin-left: 0;
}
blockquote cite {
	font-size: 14px;
	line-height: 20px;
	color: #bfbfbf;
}
blockquote cite:before {
	content: "\2014 \00A0";
}

blockquote p {
	color: #666;
}
hr {
	text-align: left;
	color: #999;
	height: 2px;
	padding: 0;
	margin: 16px 0;
	background-color: #e7e7e7;
	border: 0 none;
}

dl {
	padding: 0;
}

dl dt {
	padding: 10px 0;
	margin-top: 16px;
	font-size: 1em;
	font-style: italic;
	font-weight: bold;
}

dl dd {
	padding: 0 16px;
	margin-bottom: 16px;
}

dd {
	margin-left: 0;
}

table {
	*border-collapse: collapse; /* IE7 and lower */
	border-spacing: 0;
	width: 100%;
}
table {
	border: solid #ccc 1px;
	-moz-border-radius: 6px;
	-webkit-border-radius: 6px;
	border-radius: 6px;
	/*-webkit-box-shadow: 0 1px 1px #ccc;
    -moz-box-shadow: 0 1px 1px #ccc;
    box-shadow: 0 1px 1px #ccc;   */
}
table tr:hover {
	background: #fbf8e9;
	-o-transition: all 0.1s ease-in-out;
	-webkit-transition: all 0.1s ease-in-out;
	-moz-transition: all 0.1s ease-in-out;
	-ms-transition: all 0.1s ease-in-out;
	transition: all 0.1s ease-in-out;
}
table td,
.table th {
	border-left: 1px solid #ccc;
	border-top: 1px solid #ccc;
	padding: 10px;
	text-align: left;
}

table th {
	background-color: #dce9f9;
	background-image: -webkit-gradient(
		linear,
		left top,
		left bottom,
		from(#ebf3fc),
		to(#dce9f9)
	);
	background-image: -webkit-linear-gradient(to top, #ebf3fc, #dce9f9);
	background-image: -moz-linear-gradient(to top, #ebf3fc, #dce9f9);
	background-image: -ms-linear-gradient(to top, #ebf3fc, #dce9f9);
	background-image: -o-linear-gradient(to top, #ebf3fc, #dce9f9);
	background-image: linear-gradient(to top, #ebf3fc, #dce9f9);
	/*-webkit-box-shadow: 0 1px 0 rgba(255,255,255,.8) inset;
    -moz-box-shadow:0 1px 0 rgba(255,255,255,.8) inset;
    box-shadow: 0 1px 0 rgba(255,255,255,.8) inset;*/
	border-top: none;
	text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);
	padding: 5px;
}

table td:first-child,
table th:first-child {
	border-left: none;
}

table th:first-child {
	-moz-border-radius: 6px 0 0 0;
	-webkit-border-radius: 6px 0 0 0;
	border-radius: 6px 0 0 0;
}
table th:last-child {
	-moz-border-radius: 0 6px 0 0;
	-webkit-border-radius: 0 6px 0 0;
	border-radius: 0 6px 0 0;
}
table th:only-child {
	-moz-border-radius: 6px 6px 0 0;
	-webkit-border-radius: 6px 6px 0 0;
	border-radius: 6px 6px 0 0;
}
table tr:last-child td:first-child {
	-moz-border-radius: 0 0 0 6px;
	-webkit-border-radius: 0 0 0 6px;
	border-radius: 0 0 0 6px;
}
table tr:last-child td:last-child {
	-moz-border-radius: 0 0 6px 0;
	-webkit-border-radius: 0 0 6px 0;
	border-radius: 0 0 6px 0;
}

.markdown-body {
	box-shadow: none !important;
}
</style>
